// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/myAccount/drop-arrow-gray.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DM Sans", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap") format("woff");
}
@font-face {
  font-family: "Inter", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap") format("woff");
}
@font-face {
  font-family: "Source Sans Pro", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap") format("woff");
}
body {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  background: #ffffff;
}

.myAccount_account-summary__3yI4A a {
  text-decoration: none;
}

.myAccount_account-summary__3yI4A button {
  position: relative;
  min-height: 110px;
  border-left: 3px solid #b0b0b0 !important;
  background-color: #d9d9d9 !important;
  z-index: 9;
  padding: 16px !important;
  color: #666666 !important;
  text-decoration: none;
  margin-bottom: 5px !important;
  border-radius: 0px !important;
  text-align: left;
  width: 100%;
}
.myAccount_account-summary__3yI4A button .myAccount_fs-20__XSFSL {
  font-size: 20px;
}
@media (min-width: 768px) and (max-width: 1024px) {
  .myAccount_account-summary__3yI4A button .myAccount_fs-20__XSFSL {
    font-size: 16px;
    line-height: 1.2;
  }
}
.myAccount_account-summary__3yI4A button .myAccount_fs-12__EJALC {
  font-size: 12px;
}
.myAccount_account-summary__3yI4A button:hover {
  background: #e6e9ee !important;
  color: #666666 !important;
}
.myAccount_account-summary__3yI4A button .myAccount_acc-help-contact__8M829 {
  color: #0A1AB4;
}
.myAccount_account-summary__3yI4A button .myAccount_acc-help-contact__8M829:hover {
  color: #0A1AB4;
  text-decoration: none;
}
.myAccount_account-summary__3yI4A button .myAccount_acc-help-email__hVE92 {
  text-decoration: underline;
  color: #0A1AB4;
}

.myAccount_account-summary__3yI4A .myAccount_app-info__Ll1Dx {
  margin-bottom: 16px;
  font-size: 13px;
  font-weight: 700;
  color: #666666;
  line-height: 1.1;
  padding-right: 15px;
}
.myAccount_account-summary__3yI4A .myAccount_download-app__cCtwC img {
  max-width: 92%;
}

.myAccount_account-summary__3yI4A .myAccount_bg-darkgrey__bXoFW {
  background-color: #9e9e9e !important;
  color: #ffffff !important;
  border-left: 3px solid #6c757d !important;
}
.myAccount_account-summary__3yI4A .myAccount_bg-darkgrey__bXoFW:hover {
  background: #b8babf !important;
  color: #ffffff !important;
}

.myAccount_account-summary__3yI4A button.myAccount_active__dCRpm {
  margin-right: -15px;
  border-left: 3px solid #00703c !important;
  background: #73c573 !important;
  color: #ffffff !important;
}
.myAccount_account-summary__3yI4A button.myAccount_active__dCRpm:after {
  position: absolute;
  top: 0;
  right: -10px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border-color: transparent transparent transparent #73c573 !important;
  border-style: solid;
  border-width: 10px 0 10px 10px;
  content: "";
}
.myAccount_account-summary__3yI4A button.myAccount_active__dCRpm .myAccount_fs-20__XSFSL {
  font-size: 26px;
  font-weight: 300;
}
@media (min-width: 768px) and (max-width: 1024px) {
  .myAccount_account-summary__3yI4A button.myAccount_active__dCRpm .myAccount_fs-20__XSFSL {
    font-size: 20px;
    line-height: 1.2;
  }
}
.myAccount_account-summary__3yI4A button.myAccount_active__dCRpm .myAccount_acc-help-contact__8M829 {
  color: #0A1AB4;
}
.myAccount_account-summary__3yI4A button.myAccount_active__dCRpm .myAccount_acc-help-contact__8M829:hover {
  color: #0A1AB4;
  text-decoration: none;
}

/* user details strip css start */
.myAccount_user-info-card__a1O47 {
  font-family: "Source Sans Pro", sans-serif;
}
.myAccount_user-info-card__a1O47 a {
  text-decoration: none;
}
.myAccount_user-info-card__a1O47 .myAccount_user-name__mtJx7 {
  margin-bottom: 10px;
  font-size: 26px;
  font-weight: 300;
  line-height: 1.2;
  color: #1c1c1c;
}
@media (max-width: 767px) {
  .myAccount_user-info-card__a1O47 .myAccount_user-name__mtJx7 {
    color: #1d6c3a;
  }
}
.myAccount_user-info-card__a1O47 .myAccount_cust-detail__ep34h {
  font-size: 14px;
  font-weight: 300;
  line-height: 1.2;
  color: #1c1c1c;
}
.myAccount_user-info-card__a1O47 .myAccount_service-addr__j0RB7 {
  font-size: 16px;
  font-weight: 300;
  line-height: 1.2;
  color: #1c1c1c;
}
.myAccount_user-info-card__a1O47 .myAccount_service-addr-option__QQeUB {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  height: 40px;
  min-height: 0;
  max-width: 100%;
  padding: 0 50px 0 5px;
  font-size: 14px;
  border: 1px solid #e6e9ee;
  color: #222222;
  font-weight: 300;
}
.myAccount_user-info-card__a1O47 .myAccount_bg-yellow__ZcB9K {
  background: #FFB034;
  color: #ffffff;
  min-height: 40px;
  padding: 0 6px;
  line-height: 0.9;
}
.myAccount_user-info-card__a1O47 .myAccount_bg-yellow__ZcB9K .myAccount_font-italic__LtZvR {
  font-size: 20px;
  font-style: italic;
  font-weight: 300;
}
.myAccount_user-info-card__a1O47 .myAccount_bg-yellow__ZcB9K .myAccount_font-italic__LtZvR strong {
  font-weight: 700;
}
.myAccount_user-info-card__a1O47 .myAccount_bg-yellow__ZcB9K .myAccount_prepay-text__g5UEp {
  font-size: 14px;
}
.myAccount_user-info-card__a1O47 .myAccount_bg-lightdark__0sP\\+M {
  background: #858585;
  color: #ffffff;
  min-height: 40px;
  padding: 0 6px;
  line-height: 0.9;
}
.myAccount_user-info-card__a1O47 .myAccount_bg-lightdark__0sP\\+M .myAccount_font-italic__LtZvR {
  font-size: 20px;
  font-style: italic;
  font-weight: 300;
}
.myAccount_user-info-card__a1O47 .myAccount_bg-lightdark__0sP\\+M .myAccount_font-italic__LtZvR strong {
  font-weight: 700;
}
.myAccount_user-info-card__a1O47 .myAccount_bg-lightdark__0sP\\+M .myAccount_easypay-text__u4e9S {
  font-size: 8px;
}
.myAccount_user-info-card__a1O47 .myAccount_bg-dark__ZzrVS {
  background-color: #414141 !important;
  padding: 10px;
  font-size: 20px;
  font-weight: 700;
  line-height: 0.9;
}
.myAccount_user-info-card__a1O47 .myAccount_bg-green__ZIdpc {
  background-color: #73c573 !important;
  padding: 10px;
  font-size: 20px;
  font-weight: 700;
  line-height: 0.9;
}
.myAccount_user-info-card__a1O47 a:hover {
  text-decoration: none;
}
@media (max-width: 767px) {
  .myAccount_user-info-card__a1O47 .myAccount_service-addr__j0RB7 {
    padding-top: 20px;
    padding-bottom: 10px;
  }
  .myAccount_user-info-card__a1O47 .myAccount_servie-dropdown-sec__J\\+DZN {
    flex-direction: column;
    gap: 5px !important;
  }
}

/* user details strip css end */
.myAccount_mt-sm-72__K8lo2 {
  margin-top: 72px; /* For small screens */
}

@media (min-width: 576) { /* Large screens and above */
  .myAccount_mt-sm-72__K8lo2 {
    margin-top: 0; /* Remove margin on large screens */
  }
}
@media screen and (max-width: 767px) {
  .myAccount_account-summary-mob__LhtuU a {
    text-decoration: none;
  }
  .myAccount_account-summary-mob__LhtuU button {
    background-color: #9e9e9e !important;
    margin-bottom: 2px;
    border-radius: 0px !important;
    font-size: 24px;
    font-weight: 300;
    line-height: 2;
    color: #ffffff !important;
    text-decoration: none;
    text-align: left;
    padding: 0 15px;
    width: 100%;
  }
  .myAccount_card-info__MtvJ\\+ {
    background: #73c573 !important;
    color: #ffffff !important;
    position: relative;
    padding: 20px;
  }
  .myAccount_card-info__MtvJ\\+:after {
    position: absolute;
    right: 0;
    bottom: -10px;
    left: 0;
    width: 0;
    height: 0;
    margin: auto;
    border-color: #73c573 transparent transparent;
    border-style: solid;
    border-width: 10px 10px 0;
    content: "";
  }
  .myAccount_card-info__MtvJ\\+ .myAccount_tab-heading__ybxDK {
    font-size: 30px;
    margin-bottom: 6px;
    line-height: 1.1;
    color: #ffffff;
    font-weight: 300;
  }
  .myAccount_card-info__MtvJ\\+ .myAccount_tab-description__4fl2a {
    font-size: 20px;
    font-weight: 300;
    line-height: 1.1;
    color: #ffffff;
  }
}
select {
  border: 2px solid #e6e6e9 !important;
}
select:focus {
  outline: none;
  border: 2px solid #222222 !important;
  box-shadow: none !important;
  border-radius: 5px !important;
}

@media screen and (max-width: 767px) {
  .myAccount_mobile-help__HWzmY {
    font-size: 20px;
    margin-top: 30px;
  }
  .myAccount_mobile-help__HWzmY .myAccount_acc-help-contact__8M829 {
    color: #0d6efd;
    font-size: 20px;
    text-decoration: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/base/_fonts.scss","webpack://./src/styles/myAccount/myAccount.module.scss","webpack://./src/styles/abstracts/_variables.scss"],"names":[],"mappings":"AAOA;EACE,kCAAA;EACA,oRAAA;ACHF;ADQA;EACE,gCAAA;EACA,wPAAA;ACNF;ADUA;EACE,0CAAA;EACA,wWAAA;ACRF;AAZA;EACI,WC2GK;ED1GL,YCmHM;EDlHN,sBAAA;EACA,mBC2CI;AD7BR;;AAZA;EACI,qBAAA;AAeJ;;AAbA;EACI,kBAAA;EACA,iBAAA;EACA,yCAAA;EACA,oCAAA;EACA,UAAA;EACA,wBAAA;EACA,yBAAA;EACA,qBAAA;EACA,6BAAA;EACA,6BAAA;EACA,gBAAA;EACA,WAAA;AAgBJ;AAfI;EACI,eAAA;AAiBR;AAhBQ;EAFJ;IAGQ,eAAA;IACA,gBAAA;EAmBV;AACF;AAjBI;EACI,eAAA;AAmBR;AAjBI;EACI,8BAAA;EACA,yBAAA;AAmBR;AAjBI;EACI,cCkDD;AD/BP;AAlBQ;EACI,cCgDL;ED/CK,qBAAA;AAoBZ;AAjBI;EACI,0BAAA;EACA,cC0CD;ADvBP;;AAfI;EACI,mBAAA;EACA,eAAA;EACA,gBCmFH;EDlFG,cCQO;EDPP,gBAAA;EACA,mBAAA;AAkBR;AAfQ;EACI,cAAA;AAiBZ;;AAbA;EACI,oCAAA;EACA,yBAAA;EACA,yCAAA;AAgBJ;AAfI;EACI,8BAAA;EACA,yBAAA;AAiBR;;AAdA;EACQ,mBAAA;EACA,yCAAA;EACA,8BAAA;EACA,yBAAA;AAiBR;AAhBQ;EACI,kBAAA;EACA,MAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,oEAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AAkBZ;AAhBQ;EACI,eAAA;EACA,gBCuCP;ADrBL;AAjBY;EAHJ;IAIQ,eAAA;IACA,gBAAA;EAoBd;AACF;AAlBQ;EACI,cCZL;ADgCP;AAnBY;EACI,cCdT;EDeS,qBAAA;AAqBhB;;AAhBA,iCAAA;AACA;EACI,0CCkCgB;ADfpB;AAlBI;EACI,qBAAA;AAoBR;AAlBI;EACI,mBAAA;EACA,eAAA;EACA,gBCeH;EDdG,gBAAA;EACA,cCtDC;AD0ET;AAnBQ;EANJ;IAOQ,cAAA;EAsBV;AACF;AApBI;EACI,eAAA;EACA,gBCMH;EDLG,gBAAA;EACA,cC/DC;ADqFT;AApBI;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cCrEC;AD2FT;AApBI;EAGI,gBAAA;EACA,yDAAA;EACA,yBAAA;EACA,4BAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,cCrGD;EDsGC,gBCnBH;ADyCL;AApBI;EACI,mBCrEA;EDsEA,cC3GA;ED4GA,gBAAA;EACA,cAAA;EACA,gBAAA;AAsBR;AArBQ;EACI,eAAA;EACA,kBAAA;EACA,gBC9BP;ADqDL;AAtBY;EACI,gBC5BX;ADoDL;AArBQ;EACI,eAAA;AAuBZ;AApBI;EACI,mBCzGC;ED0GD,cC7HA;ED8HA,gBAAA;EACA,cAAA;EACA,gBAAA;AAsBR;AArBQ;EACI,eAAA;EACA,kBAAA;EACA,gBChDP;ADuEL;AAtBY;EACI,gBC9CX;ADsEL;AArBQ;EACI,cAAA;AAuBZ;AApBI;EACI,oCAAA;EACA,aCxEG;EDyEH,eAAA;EACA,gBCzDH;ED0DG,gBAAA;AAsBR;AApBI;EACI,oCAAA;EACA,aC/EG;EDgFH,eAAA;EACA,gBChEH;EDiEG,gBAAA;AAsBR;AAnBQ;EACI,qBAAA;AAqBZ;AAlBI;EACI;IACI,iBAAA;IACA,oBAAA;EAoBV;EAlBM;IACI,sBAAA;IACA,mBAAA;EAoBV;AACF;;AAjBA,+BAAA;AAGA;EACE,gBAAA,EAAA,sBAAA;AAkBF;;AAfA,0BAAA,4BAAA;EACE;IACE,aAAA,EAAA,mCAAA;EAkBF;AACF;AAfA;EAEQ;IACI,qBAAA;EAgBV;EAbM;IACI,oCAAA;IACA,kBAAA;IACA,6BAAA;IACA,eAAA;IACA,gBAAA;IACA,cAAA;IACA,yBAAA;IACA,qBAAA;IACA,gBAAA;IACA,eAAA;IACA,WAAA;EAeV;EAZE;IACI,8BAAA;IACA,yBAAA;IACA,kBAAA;IACA,aCtIG;EDoJT;EAbM;IACQ,kBAAA;IACA,QAAA;IACA,aAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,YAAA;IACA,6CAAA;IACA,mBAAA;IACA,yBAAA;IACA,WAAA;EAed;EAbM;IACI,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,cClOJ;IDmOI,gBC/IP;ED8JH;EAbM;IACI,eAAA;IACA,gBCnJP;IDoJO,gBAAA;IACA,cCzOJ;EDwPN;AACF;AAPA;EACI,oCAAA;AASJ;AARI;EAEI,aAAA;EACA,oCAAA;EACA,2BAAA;EACA,6BAAA;AASR;;AAJA;EACI;IACI,eAAA;IACA,gBAAA;EAON;EALM;IACI,cAAA;IACA,eAAA;IACA,qBAAA;EAOV;AACF","sourcesContent":["// -----------------------------------------------------------------------------\n// This file contains all @font-face declarations, if any.\n// -----------------------------------------------------------------------------\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap');\n\n@font-face {\n  font-family: \"DM Sans\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap') format('woff2'),\n  url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap') format('woff');\n  \n}\n\n@font-face {\n  font-family: \"Inter\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap') format('woff2'),\n       url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap') format('woff');\n}\n\n@font-face {\n  font-family: \"Source Sans Pro\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap') format('woff2'),\n       url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap') format('woff');\n}","@use '../abstracts/variables' as *;\n\nbody {\n    margin: $margin0;\n    padding: $padding0;\n    box-sizing: border-box;\n    background: $white;\n}\n.account-summary a{\n    text-decoration: none;\n}\n.account-summary button{\n    position: relative;\n    min-height: 110px;\n    border-left: 3px solid $bl-darkgrey !important;\n    background-color: $grey7 !important;\n    z-index: 9;\n    padding: $padding16 !important;\n    color: $light-gray2 !important;\n    text-decoration: none;\n    margin-bottom: 5px !important;\n    border-radius: $br-0 !important;\n    text-align: left;   \n    width:100%; \n    .fs-20{\n        font-size: 20px;\n        @media (min-width: 768px) and (max-width: 1024px) {\n            font-size: 16px;\n            line-height: 1.2;\n        }\n    }\n    .fs-12{\n        font-size: 12px;\n    }\n    &:hover{\n        background: $grey8 !important;\n        color: $light-gray2 !important;\n    }\n    .acc-help-contact{\n        color: $blue;\n        &:hover{\n            color: $blue;\n            text-decoration: none;\n        }\n    }\n    .acc-help-email{\n        text-decoration: underline;\n        color: $blue;\n    }\n}\n.account-summary{\n    .app-info{\n        margin-bottom: 16px;\n        font-size: 13px;\n        font-weight: $fw7;\n        color: $light-gray2;\n        line-height: 1.1;\n        padding-right: 15px;\n    }\n    .download-app{\n        img{\n            max-width: 92%;\n        }\n    }\n}    \n.account-summary .bg-darkgrey{\n    background-color: $grey5 !important;\n    color: $white !important;\n    border-left: 3px solid $bl-grey !important;\n    &:hover {\n        background: $hover-grey !important;\n        color: $white !important;\n    }\n}\n.account-summary button.active{\n        margin-right: -15px;\n        border-left: 3px solid $bl-green !important;\n        background: $green4 !important;\n        color: $white !important;\n        &:after{\n            position: absolute;\n            top: 0;\n            right: -10px;\n            bottom: 0;\n            width: 0;\n            height: 0;\n            margin: auto;\n            border-color: transparent transparent transparent $green4 !important;\n            border-style: solid;\n            border-width: 10px 0 10px 10px;\n            content: \"\";\n        }\n        .fs-20{\n            font-size: 26px;\n            font-weight: $fw3;\n            @media (min-width: 768px) and (max-width: 1024px) {\n                font-size: 20px;\n                line-height: 1.2;\n            }\n        }\n        .acc-help-contact{\n            color: $blue;\n            &:hover{\n                color: $blue;\n                text-decoration: none;\n            }\n        }\n}            \n\n/* user details strip css start */\n.user-info-card{\n    font-family: $source-sans-pro;\n    a{\n        text-decoration: none;\n    }\n    .user-name{\n        margin-bottom: 10px;\n        font-size: 26px;\n        font-weight: $fw3;\n        line-height: 1.2;\n        color: $grey4;\n        @media (max-width: 767px) {\n            color: #1d6c3a;\n        }\n    }\n    .cust-detail{\n        font-size: 14px;\n        font-weight: $fw3;\n        line-height: 1.2;\n        color: $grey4;        \n    }\n    .service-addr{\n        font-size: 16px;\n        font-weight: $fw3;\n        line-height: 1.2;\n        color: $grey4;        \n    }\n    .service-addr-option{\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        background-image: url(../../../public/images/myAccount/drop-arrow-gray.png);\n        background-position: 100%;\n        background-repeat: no-repeat;\n        background-size: contain;\n        height: 40px;\n        min-height: 0;\n        max-width: 100%;\n        padding: 0 50px 0 5px;\n        font-size: 14px;\n        border: 1px solid $grey8;\n        color: $gray;\n        font-weight: $fw3;\n    }\n    .bg-yellow{\n        background: $yellow;\n        color: $white;\n        min-height:40px;\n        padding: 0 6px;\n        line-height: 0.9;\n        .font-italic{\n            font-size: 20px;\n            font-style: italic;\n            font-weight: $fw3;\n            strong{\n                font-weight: $fw7;\n            }\n        }\n        .prepay-text{\n            font-size: 14px;\n        }\n    }\n    .bg-lightdark{\n        background: $grey6;\n        color: $white;\n        min-height:40px;\n        padding: 0 6px;\n        line-height: 0.9;\n        .font-italic{\n            font-size: 20px;\n            font-style: italic;\n            font-weight: $fw3;\n            strong{\n                font-weight: $fw7;\n            }\n        }\n        .easypay-text{\n            font-size: 8px;\n        }\n    }\n    .bg-dark{\n        background-color: $light-gray !important;\n        padding: $padding10;\n        font-size: 20px;\n        font-weight: $fw7;\n        line-height: 0.9;\n    }\n    .bg-green{\n        background-color: $green4 !important;\n        padding: $padding10;\n        font-size: 20px;\n        font-weight: $fw7;\n        line-height: 0.9;\n    }\n    a{\n        &:hover{\n            text-decoration: none;\n        }\n    }\n    @media (max-width: 767px) {\n        .service-addr{\n            padding-top: 20px;\n            padding-bottom: 10px;\n        }\n        .servie-dropdown-sec{\n            flex-direction: column;\n            gap: 5px !important;\n        }\n    }\n}     \n/* user details strip css end */\n\n\n.mt-sm-72 {\n  margin-top: 72px; /* For small screens */\n}\n\n@media (min-width: 576) { /* Large screens and above */\n  .mt-sm-72 {\n    margin-top: 0; /* Remove margin on large screens */\n  }\n}\n\n@media screen and (max-width:767px) {\n    .account-summary-mob{\n        a{\n            text-decoration: none;\n        }\n\n        button{\n            background-color: $grey5 !important;\n            margin-bottom: 2px;\n            border-radius: $br-0 !important;\n            font-size: 24px;\n            font-weight: 300;\n            line-height: 2;\n            color: $white !important;\n            text-decoration: none;\n            text-align: left;\n            padding: 0 15px;\n            width: 100%;\n        }   \n    }\n    .card-info{\n        background: $green4 !important;\n        color: $white !important;\n        position: relative;\n        padding: $padding20;\n        &:after{\n                position: absolute;\n                right: 0;\n                bottom: -10px;\n                left: 0;\n                width: 0;\n                height: 0;\n                margin: auto;\n                border-color: $green4 transparent transparent;\n                border-style: solid;\n                border-width: 10px 10px 0;\n                content: \"\";\n        }\n        .tab-heading{\n            font-size: 30px;\n            margin-bottom: 6px;\n            line-height: 1.1;\n            color: $white;\n            font-weight: $fw3;\n        }\n        .tab-description{\n            font-size: 20px;\n            font-weight: $fw3;\n            line-height: 1.1;\n            color: $white;\n        }\n        \n    }\n}\n@media screen and (min-width:768px) and (max-width:1024px){\n\n}\n\nselect {\n    border: 2px solid $grey9 !important;\n    &:focus{\n        \n        outline: none;\n        border: 2px solid $gray !important;\n        box-shadow: none !important;\n        border-radius: 5px !important;\n        \n    }\n}\n\n@media screen and (max-width:767px) {\n    .mobile-help {\n        font-size: 20px;\n        margin-top: 30px;\n\n        .acc-help-contact{\n            color: #0d6efd;\n            font-size: 20px;\n            text-decoration: none;\n        }\n    }\n}   ","// -----------------------------------------------------------------------------\n// This file contains all application-wide Sass variables.\n// -----------------------------------------------------------------------------\n\n\n//Fonts \n\n\n@import \"../base/fonts\";\n\n\n$roboto-regular : 'Roboto-regular';\n$roboto-bold: 'Roboto-bold';\n$roboto-medium: 'Roboto-medium';\n$roboto-light-italic: 'Roboto-light-italic';\n\n/// Regular font family\n/// @type List\n//$text-font-stack: 'Open Sans', 'Helvetica Neue Light', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif !default;\n\n/// Code (monospace) font family\n/// @type List\n//$code-font-stack: 'Courier New', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Monaco', monospace !default;\n\n\n\n\n\n/// Copy text color\n/// @type Color\n$text-color: rgb(34, 34, 34) !default;\n\n/// Main brand color\n/// @type Color\n$brand-color: rgb(229, 0, 80) !default;\n\n/// Light grey\n/// @type Color\n$light-grey: rgb(237, 237, 237) !default;\n\n/// Medium grey\n/// @type Color\n$mid-grey: rgb(153, 153, 153) !default;\n\n/// Dark grey\n/// @type Color\n$dark-grey: rgb(68, 68, 68) !default;\n\n$black: #000000;\n$white: #ffffff;\n$gray: #222222;\n$grey3 : #939393;\n$grey4 : #1c1c1c;\n$grey5 : #9e9e9e;\n$grey6 : #858585;\n\n$hover-grey: #b8babf;\n$gray7:#333333;\n$gray8:#CCCCCC;\n$gray9:#dddddd;\n$gray10:#57606a;\n$gray11:#999999;\n$light-gray : #414141;\n$light-gray2 : #666666;\n$gray2 : #4F4F4F;\n$grey3 : #939393;\n$grey4 : #1c1c1c;\n$grey5 : #9e9e9e;\n$grey6 : #858585;\n$grey7 : #d9d9d9;\n$grey8 : #e6e9ee;\n$grey9 : #e6e6e9;\n$hover-grey: #b8babf;\n$stone : #CACACA;\n$gray-bg :#EBF9F0;\n$green:#046A38;\n$green2:#1EE576;\n$green3:#19C063;\n$green5:#2a8056;\n$green4:#73c573;\n$green7:#70c66f;\n$dark-green:#00873C;\n$light-green:#00B140;\n$light-green1 : #4f785f;\n$red : #FF0000;\n$light-red:#ff3c3c;\n$yellow:#FFB034;\n$dark-yellow:#e2a014;\n$yellow-hover:#cd7d00;\n$blue :#0A1AB4;\n$orange:#EA6B1F;\n$purple:#6A1B85;\n$offwhite:#F5F7F5;\n$offwhite1:#E0E0E0;\n$bg-grey-login:#f2f3f6;\n$border-grey: #ced4da;\n$bl-grey: #6c757d;\n$bl-green:#00703c;\n$bl-darkgrey: #b0b0b0;\n$bg-white1:#F5F5F5;\n$bg-white2:#FAFAFA;\n$red1: #d1002f;\n\n$yellow-hover:#cd7d00;\n\n\n$font-dm: \"DM Sans\", sans-serif;\n$font-inter: Inter;\n$font-inter-ss: \"Inter\", sans-serif;\n\n$margin0:0px;\n$margin10:10px;\n$margin15:15px; \n$margin20:20px;\n$margin30:30px; \n$margin40:40px;\n$margin50:50px;\n$margin60:60px;\n\n$padding0:0px;\n$padding10:10px;\n$padding15:15px;    \n$padding16:16px;    \n$padding20:20px;\n$padding30:30px;  \n$padding40:40px;\n$padding50:50px;\n\n$br-0:0px;\n\n$br-0:0px;\n$fw1:100;\n$fw2:200;\n$fw3:300;\n$fw4:400;\n$fw5:500;\n$fw6:600;\n$fw7:700;\n$fw8:800;\n$fw9:900;\n\n$font-dm: \"DM Sans\", sans-serif;\n$font-inter: Inter;\n$font-inter-ss: \"Inter\", sans-serif;\n\n$source-sans-pro:   \"Source Sans Pro\" , sans-serif ;\n\n/// Container's maximum width\n/// @type Length\n$max-width: 1180px !default;\n\n\n\n\n\n/// Breakpoints map\n/// @prop {String} keys - Keys are identifiers mapped to a given length\n/// @prop {Map} values - Values are actual breakpoints expressed in pixels\n$breakpoints: (\n  'small': 320px,\n  'medium': 768px,\n  'large': 1024px,\n) !default;\n\n\n\n\n\n\n/// Relative or absolute URL where all assets are served from\n/// @type String\n/// @example scss - When using a CDN\n///   $base-url: 'https://cdn.example.com/assets/';\n$base-url: '/assets/' !default;\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"account-summary": `myAccount_account-summary__3yI4A`,
	"fs-20": `myAccount_fs-20__XSFSL`,
	"fs-12": `myAccount_fs-12__EJALC`,
	"acc-help-contact": `myAccount_acc-help-contact__8M829`,
	"acc-help-email": `myAccount_acc-help-email__hVE92`,
	"app-info": `myAccount_app-info__Ll1Dx`,
	"download-app": `myAccount_download-app__cCtwC`,
	"bg-darkgrey": `myAccount_bg-darkgrey__bXoFW`,
	"active": `myAccount_active__dCRpm`,
	"user-info-card": `myAccount_user-info-card__a1O47`,
	"user-name": `myAccount_user-name__mtJx7`,
	"cust-detail": `myAccount_cust-detail__ep34h`,
	"service-addr": `myAccount_service-addr__j0RB7`,
	"service-addr-option": `myAccount_service-addr-option__QQeUB`,
	"bg-yellow": `myAccount_bg-yellow__ZcB9K`,
	"font-italic": `myAccount_font-italic__LtZvR`,
	"prepay-text": `myAccount_prepay-text__g5UEp`,
	"bg-lightdark": `myAccount_bg-lightdark__0sP+M`,
	"easypay-text": `myAccount_easypay-text__u4e9S`,
	"bg-dark": `myAccount_bg-dark__ZzrVS`,
	"bg-green": `myAccount_bg-green__ZIdpc`,
	"servie-dropdown-sec": `myAccount_servie-dropdown-sec__J+DZN`,
	"mt-sm-72": `myAccount_mt-sm-72__K8lo2`,
	"account-summary-mob": `myAccount_account-summary-mob__LhtuU`,
	"card-info": `myAccount_card-info__MtvJ+`,
	"tab-heading": `myAccount_tab-heading__ybxDK`,
	"tab-description": `myAccount_tab-description__4fl2a`,
	"mobile-help": `myAccount_mobile-help__HWzmY`
};
export default ___CSS_LOADER_EXPORT___;
